import React from "react";

import { getIntegrationForKey, type renderPillArgument } from "~/integrations/actionItemIntegration";
import { WidgetInner } from "~/integrations/actionItemIntegration/Widget";

import clickupPill from "./css/clickupPill.module.css";

export const clickupSpecificDataNodeTypename = "ClickupActionItemIntegrationSpecificDataNode";

export function ClickupActionItemIntegrationLinkWidget({ actionItemLink, customClassName }: renderPillArgument) {
	if (actionItemLink.integrationData.__typename !== clickupSpecificDataNodeTypename) {
		throw new Error("Incorrect integration to render pill");
	}
	const clickupData = actionItemLink.integrationData;

	const updating = actionItemLink.syncStatus !== "DONE_SYNCING_EXTERNALLY";

	const id = clickupData.externalTaskId;
	const url = `https://app.clickup.com/t/${id}`;

	const tooltip = clickupData.listName ?? undefined;

	const logo = getIntegrationForKey("CLICKUP").logo;

	return (
		<WidgetInner tooltip={tooltip} logo={logo} updating={updating} url={url} customClassName={customClassName}>
			{clickupData.status && clickupData.statusColor ? (
				<div className={clickupPill.innerContent}>
					{clickupData.status}
					<div className={clickupPill.statusColor} style={{ background: clickupData.statusColor }} />
				</div>
			) : (
				"Syncing"
			)}
		</WidgetInner>
	);
}
